module.exports = __webpack_public_path__ + "img/receipt.0bab1d9e.svg";